import { AlertCircle } from 'lucide-react';
import { useBranding } from '@/features/branding';

interface AccountUnavailableScreenProps {
  /** Mensagem vinda do backend. */
  message?: string | null;
}

/**
 * AccountUnavailableScreen — bloqueio de ciclo de vida da ORG (HTTP 403
 * `ORG_SUSPENDED`).
 *
 * Exibida quando a organização (white-label) está SUSPENDED/DEPROVISIONING/
 * DELETED — bloqueia TODOS os tenants daquela org. É um gate administrativo,
 * NÃO billing: **não há CTA de pagamento** (pagar não resolve). Aponta o
 * usuário para o suporte do white-label quando disponível.
 *
 * Epic #884 §3.1 (Gate 1) / Fase 3.
 */
export function AccountUnavailableScreen({
  message,
}: AccountUnavailableScreenProps) {
  const { branding } = useBranding();
  const supportEmail = branding.supportEmail;

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
      <div className="w-full max-w-md rounded-xl border bg-card p-8 text-center shadow-sm">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-muted">
          <AlertCircle
            className="h-7 w-7 text-muted-foreground"
            aria-hidden="true"
          />
        </div>

        <h1 className="text-xl font-semibold text-foreground">
          Conta indisponível
        </h1>

        <p className="mt-3 text-sm text-muted-foreground">
          {message ??
            'Esta conta está temporariamente indisponível. Entre em contato com o suporte para mais informações.'}
        </p>

        {supportEmail && (
          <p className="mt-4 text-sm">
            <a
              href={`mailto:${supportEmail}`}
              className="font-medium text-primary hover:underline"
            >
              {supportEmail}
            </a>
          </p>
        )}
      </div>
    </div>
  );
}
